import { ReactNode } from "react";
import { AiOutlineClose } from "react-icons/ai";

interface ModalProps {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
  size?: "sm" | "md" | "lg" | "xl" | "full";
}

const sizeClasses: Record<NonNullable<ModalProps["size"]>, string> = {
  sm: "w-[100%] sm:w-[480px]",
  md: "w-[100%] sm:w-[640px]",
  lg: "w-[100%] sm:w-[860px]",
  xl: "w-[100%] sm:w-[1024px]",
  full: "w-[90vw] max-w-[1280px]",
};

export const FormModal = ({ open, onClose, children, size = "lg" }: ModalProps) => {
  if (!open) return null;

  const widthClass = sizeClasses[size];

  return (
    <div className="fixed inset-0 flex items-start justify-center bg-black/80 z-[1000] pt-10">
      <div
        className={`relative bg-white rounded-xl p-5 flex flex-col max-h-[calc(100vh-100px)] overflow-hidden ${widthClass} shadow-lg`}
      >
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-700 text-2xl hover:text-[#47a81e] transition-colors"
          >
            <AiOutlineClose />
          </button>
        )}

        <div className="overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};
